import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  MenuItem,
  Radio,
  RadioGroup,
  Switch,
  TextField,
} from "@mui/material";
import AuthService from "../../../AuthService";
import React from "react";
import { TIPO_FORMAS_PIX } from "../payments.config";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";

const DialogFormaDePagamento = ({
  open,
  onClose,
  handleChange,
  fpInput,
  tipos,
  openPicPayHelp,
  openAsaasHelp,
  handleSave,
  handleClose,
}) => {
  const service = new AuthService();

  return (
    <Dialog fullWidth open={open} onClose={onClose}>
      <DialogTitle>Forma de pagamento</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          {service.isAdmin() && (
            <Grid size={12}>
              <FormControl component="fieldset">
                <FormLabel component="legend">Tipo Pagamento</FormLabel>
                <RadioGroup
                  style={{ flexDirection: "row" }}
                  name="tipoPagamento"
                  value={fpInput.tipoPagamento}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="local"
                    color="primary"
                    control={<Radio />}
                    label="Pagamento local"
                  />
                  <FormControlLabel
                    value="online"
                    color="primary"
                    control={<Radio />}
                    label="Pagamento online"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
          )}

          {fpInput.tipoPagamento === "online" && (
            <Grid size={12}>
              <TextField
                required
                fullWidth
                name="asaasToken"
                label="Token Asaas"
                variant="outlined"
                value={fpInput.asaasToken || ""}
                onChange={handleChange}
                InputProps={{
                  endAdornment: (
                    <IconButton onClick={openAsaasHelp} size="large">
                      <HelpOutlineIcon />
                    </IconButton>
                  ),
                }}
              />
            </Grid>
          )}

          <Grid
            size={{
              xs: 12,
              md: 12,
            }}
          >
            <TextField
              required
              onChange={handleChange}
              value={fpInput.descricao || ""}
              variant="outlined"
              label="Descrição"
              name="descricao"
              fullWidth
              inputProps={{
                style: { textTransform: "uppercase" },
              }}
            />
          </Grid>

          <Grid
            size={{
              xs: 12,
              md: 4,
            }}
          >
            <TextField
              fullWidth
              select
              name={fpInput.tipoPagamento === "online" ? "tipoOnline" : "tipo"}
              label="Tipo"
              onChange={handleChange}
              value={
                (fpInput.tipoPagamento === "online"
                  ? fpInput.tipoOnline
                  : fpInput.tipo) || ""
              }
              variant="outlined"
            >
              {tipos.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid
            size={{
              xs: 12,
              md: 4,
            }}
          >
            <TextField
              onChange={handleChange}
              value={fpInput.ordem || ""}
              variant="outlined"
              label="Ordem"
              name="ordem"
              fullWidth
            />
          </Grid>

          <Grid
            size={{
              xs: 12,
              sm: 4,
            }}
          >
            <TextField
              onChange={handleChange}
              value={fpInput.codigoExterno || ""}
              variant="outlined"
              label="Código externo"
              name="codigoExterno"
              fullWidth
            />
          </Grid>

          {fpInput.tipo === "PICPAY" ? (
            <React.Fragment>
              <Grid
                size={{
                  xs: 12,
                  md: 12,
                }}
              >
                <TextField
                  onChange={handleChange}
                  value={fpInput.picpayToken || ""}
                  variant="outlined"
                  label="Token de integração do PicPay"
                  name="picpayToken"
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <IconButton onClick={openPicPayHelp} size="large">
                        <HelpOutlineIcon />
                      </IconButton>
                    ),
                  }}
                />
              </Grid>
            </React.Fragment>
          ) : null}

          {fpInput.tipo === "PIX" && fpInput.tipoPagamento !== "online" ? (
            <React.Fragment>
              <Grid
                size={{
                  xs: 12,
                  md: 8,
                }}
              >
                <TextField
                  onChange={handleChange}
                  value={fpInput.chavePix || ""}
                  variant="outlined"
                  label="Chave Pix"
                  name="chavePix"
                  fullWidth
                />
              </Grid>

              <Grid
                size={{
                  xs: 12,
                  md: 4,
                }}
              >
                <TextField
                  fullWidth
                  select
                  name="tipoChave"
                  label="Tipo Chave"
                  onChange={handleChange}
                  value={fpInput.tipoChave || ""}
                  variant="outlined"
                >
                  {TIPO_FORMAS_PIX.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid
                size={{
                  xs: 12,
                  md: 12,
                }}
              >
                <TextField
                  onChange={handleChange}
                  value={fpInput.nomeBeneficiario || ""}
                  inputProps={{ maxLength: 25 }}
                  variant="outlined"
                  label="Nome do beneficiário"
                  name="nomeBeneficiario"
                  fullWidth
                />
              </Grid>

              <Grid
                size={{
                  xs: 12,
                  md: 12,
                }}
              >
                <TextField
                  onChange={handleChange}
                  value={fpInput.cidadeBeneficiario || ""}
                  variant="outlined"
                  label="Cidade do beneficiário"
                  name="cidadeBeneficiario"
                  fullWidth
                />
              </Grid>
            </React.Fragment>
          ) : null}
          <Box style={{ marginLeft: "20px" }}>
            <FormControlLabel
              name="ativo"
              control={
                <Switch
                  checked={fpInput.ativo}
                  color="primary"
                  onChange={() => {
                    handleChange({
                      target: { name: "ativo", value: !fpInput.ativo },
                    });
                  }}
                />
              }
              label="Forma de pagamento ativa"
            />
          </Box>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          variant="text"
          onClick={handleClose}
          startIcon={<CancelIcon />}
        >
          Cancelar
        </Button>

        <Button
          aria-expanded={true}
          variant="contained"
          color="secondary"
          onClick={handleSave}
          startIcon={<SaveIcon />}
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogFormaDePagamento;
